import React from 'react';
import { locationsData } from '../data/mock';
import { MapPin, Building, TreePine } from 'lucide-react';

const locationIcons = {
  London: Building,
  Essex: MapPin,
  Kent: TreePine
};

const LocationsSection = () => {
  return (
    <section id="locations" className="py-24 md:py-32 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="font-lato text-[#D4AF37] uppercase tracking-[0.3em] text-sm mb-4 block">Our Locations</span>
          <h2 className="font-playfair text-4xl md:text-5xl text-[#1A2B3C] mb-4">Three Exceptional Homes</h2>
          <p className="font-lato text-[#1A2B3C]/60 max-w-2xl mx-auto">
            Each of our residences offers the same uncompromising standard of luxury care,
            tailored to its unique setting.
          </p>
        </div>

        {/* Locations Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {locationsData.map((location, index) => {
            const IconComponent = locationIcons[location.name];
            return (
              <div
                key={location.id}
                className="group relative overflow-hidden rounded-xl bg-white shadow-lg hover:shadow-2xl transition-all duration-500"
              >
                {/* Headquarters Badge */}
                {location.isHeadquarters && (
                  <div className="absolute top-4 right-4 z-10 bg-[#D4AF37] text-[#1A2B3C] font-lato text-xs px-3 py-1 rounded-full font-medium tracking-wide">
                    Headquarters
                  </div>
                )}

                {/* Top decorative bar */}
                <div className="h-1.5 bg-gradient-to-r from-[#D4AF37] via-[#D4AF37]/60 to-[#D4AF37]" />

                <div className="p-8">
                  {/* Icon */}
                  <div className="w-14 h-14 mb-6 rounded-lg bg-[#1A2B3C] flex items-center justify-center group-hover:bg-[#D4AF37] transition-colors duration-500">
                    <IconComponent className="w-6 h-6 text-[#D4AF37] group-hover:text-[#1A2B3C] transition-colors duration-500" />
                  </div>

                  <h3 className="font-playfair text-2xl text-[#1A2B3C] mb-2">
                    {location.name}
                  </h3>

                  <p className="font-lato text-[#D4AF37] text-sm tracking-wide mb-4 italic">
                    {location.tagline}
                  </p>

                  <p className="font-lato text-[#1A2B3C]/60 text-sm leading-relaxed">
                    {location.description}
                  </p>

                  {/* Learn More Link */}
                  <div className="mt-6 pt-6 border-t border-[#1A2B3C]/10">
                    <button className="font-lato text-sm text-[#1A2B3C] hover:text-[#D4AF37] transition-colors duration-300 flex items-center gap-2">
                      Explore {location.name}
                      <span className="group-hover:translate-x-1 transition-transform duration-300">→</span>
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LocationsSection;
